/**
 * Cache wrapper for the Trucks list. TtlCache (15-min, single "all" entry, in-flight
 * coalescing) around `API.Data.Trucks.get.all()`. One-shot per Scheduling page load
 * (MC parity — no polling); the TTL just spares remounts a refetch.
 */

import { Truck } from "@domain/CRM/truck";
import { TtlCache } from "../../../cache/ttlCache";
import { API } from "../../../api";

const LIST_TTL_MS = 15 * 60 * 1000;
const LIST_KEY = "all" as const;

class CachedTrucksList {
	private cache = new TtlCache<typeof LIST_KEY, Truck[]>(LIST_TTL_MS, () => API.Data.Trucks.get.all());

	/** Synchronous TTL cache hit, or null if missing/expired. */
	public peek(): Truck[] | null {
		return this.cache.peek(LIST_KEY);
	}

	public get(): Promise<Truck[]> {
		return this.cache.get(LIST_KEY);
	}

	public clear(): void {
		this.cache.clear();
	}
}

export class CachedTrucksAPI {
	public list = new CachedTrucksList();
}
